import { type PayloadAction } from '@reduxjs/toolkit';

import { createAppSlice } from '../create-app-slice';
import { stateInitializer } from './state-initializer';
import { type State } from './state.type';

export const slice = createAppSlice({
	name: 'currentUser',
	initialState: stateInitializer() as State,
	reducers: (create) => ({
		setCurrentUser: create.reducer((state, action: PayloadAction<NonNullable<State>>) => {
			return action.payload;
		}),
		clearCurrentUser: create.reducer(() => {
			return null;
		})
	}),
	selectors: {
		currentUserState: (state) => state
	}
});
